module.exports = __webpack_public_path__ + "static/media/burger_feedback.909b02c8.svg";